(function () {
  var modal = null;
  var dialog = null;
  var content = null;
  var lastTrigger = null;
  var currentProduct = null;
  var selectedOptions = [];
  var selectedVariant = null;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function truncateWords(value, count) {
    var words = String(value || '').trim().split(/\s+/).filter(Boolean);
    if (words.length <= count) return words.join(' ');
    return words.slice(0, count).join(' ') + '...';
  }

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat || window.money_format || '${{amount}}').replace(/\.00/g, '');
    }
    return '$ ' + (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function normalizeValue(value) {
    if (value === null || value === undefined) return '';
    if (Array.isArray(value)) return value.join(', ');
    return String(value).trim();
  }

  function getCardData(trigger) {
    var card = trigger.closest('.av-product-card');
    var script = card ? card.querySelector('[data-av-product-quick-data]') : null;
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Unable to parse product quick-view data', error);
      return null;
    }
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (option) {
      return option !== null && option !== undefined;
    });
  }

  function findVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (variant) {
      var options = getVariantOptions(variant);
      return selectedOptions.every(function (value, index) {
        return !value || options[index] === value;
      });
    }) || product.variants[0] || null;
  }

  function getOptionImage(product) {
    return product && (product.featuredImage || (product.images && product.images[0])) || '';
  }

  function buildRating(product) {
    var reviewText = normalizeValue(product.reviewCount);
    if (reviewText && reviewText.toLowerCase().indexOf('review') === -1) {
      reviewText += ' Reviews';
    }
    return [
      '<div class="av-product-quick-view__rating">',
      '<span class="av-product-quick-view__stars" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span>',
      reviewText ? '<span>' + escapeHtml(reviewText) + '</span>' : '',
      '</div>'
    ].join('');
  }

  function buildOptions(product) {
    if (!product.options || product.options.length === 0 || product.options.length === 1 && product.options[0].name === 'Title') {
      return '';
    }

    return [
      '<div class="av-product-quick-view__options">',
      product.options.map(function (option, optionIndex) {
        var values = option.values || [];
        return [
          '<div class="av-product-quick-view__option-group">',
          '<div class="av-product-quick-view__option-label">' + escapeHtml(option.name) + ':</div>',
          '<div class="av-product-quick-view__option-values">',
          values.map(function (value) {
            var active = selectedOptions[optionIndex] === value ? ' is-active' : '';
            return '<button class="av-product-quick-view__option' + active + '" type="button" data-av-qv-option="' + optionIndex + '" data-av-qv-value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</button>';
          }).join(''),
          '</div>',
          '</div>'
        ].join('');
      }).join(''),
      '</div>'
    ].join('');
  }

  function buildSpecs(product) {
    var specs = (product.specs || []).map(function (spec) {
      return {
        label: normalizeValue(spec.label),
        value: normalizeValue(spec.value)
      };
    }).filter(function (spec) {
      return spec.label && spec.value;
    });

    if (!specs.length) return '';

    return [
      '<div class="av-product-quick-view__specs">',
      specs.map(function (spec) {
        return [
          '<div class="av-product-quick-view__spec">',
          '<div class="av-product-quick-view__spec-label">' + escapeHtml(spec.label) + '</div>',
          '<div class="av-product-quick-view__spec-value">' + escapeHtml(spec.value) + '</div>',
          '</div>'
        ].join('');
      }).join(''),
      '</div>'
    ].join('');
  }

  function buildResources(product) {
    var resources = (product.resources || []).filter(function (resource) {
      return normalizeValue(resource.label) && normalizeValue(resource.url);
    });

    if (!resources.length) return '';

    return [
      '<div class="av-product-quick-view__resources">',
      resources.map(function (resource) {
        return '<a class="av-product-quick-view__resource" href="' + escapeHtml(resource.url) + '" target="_blank" rel="noopener">' + escapeHtml(resource.label) + ' <span aria-hidden="true">&#8599;</span></a>';
      }).join(''),
      '</div>'
    ].join('');
  }

  function buildThumbs(product, activeImage) {
    var images = (product.images || []).filter(Boolean);
    if (images.length <= 1) return '';
    return [
      '<div class="av-product-quick-view__thumbs" aria-label="Product images">',
      images.map(function (image, index) {
        var active = image === activeImage || (!activeImage && index === 0) ? ' is-active' : '';
        return '<button class="av-product-quick-view__thumb' + active + '" type="button" data-av-qv-image="' + escapeHtml(image) + '" aria-label="Show image ' + (index + 1) + '"><img src="' + escapeHtml(image) + '" alt=""></button>';
      }).join(''),
      '</div>'
    ].join('');
  }

  function renderProduct(product) {
    if (!content) return;
    selectedVariant = findVariant(product);
    var image = getOptionImage(product);
    var price = selectedVariant && selectedVariant.price !== undefined ? selectedVariant.price : product.price;
    var isAvailable = selectedVariant ? selectedVariant.available !== false : product.available !== false;

    content.innerHTML = [
      '<div class="av-product-quick-view__grid">',
      '<div class="av-product-quick-view__media">',
      '<a class="av-product-quick-view__image-link" href="' + escapeHtml(product.url) + '">',
      image ? '<img class="av-product-quick-view__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '">' : '<div class="av-product-quick-view__image"></div>',
      '<span class="av-product-quick-view__details"><span class="av-product-quick-view__eye" aria-hidden="true"></span><span>View Details</span></span>',
      '</a>',
      buildThumbs(product, image),
      '</div>',
      '<div class="av-product-quick-view__info">',
      buildRating(product),
      '<h2 class="av-product-quick-view__title" id="av-product-quick-view-title">' + escapeHtml(product.title) + '</h2>',
      product.subtitle ? '<div class="av-product-quick-view__subtitle">' + escapeHtml(product.subtitle) + '</div>' : '',
      '<div class="av-product-quick-view__price" data-av-qv-price>' + formatMoney(price, product.moneyFormat) + '</div>',
      product.description ? '<div class="av-product-quick-view__mobile-description">' + escapeHtml(truncateWords(product.description, 34)) + '</div>' : '',
      buildOptions(product),
      '<div class="av-product-quick-view__purchase">',
      '<div class="av-product-quick-view__quantity">',
      '<button type="button" data-av-qv-qty-minus aria-label="Decrease quantity">&minus;</button>',
      '<input type="text" inputmode="numeric" pattern="[0-9]*" min="1" step="1" value="1" data-av-qv-qty aria-label="Quantity">',
      '<button type="button" data-av-qv-qty-plus aria-label="Increase quantity">+</button>',
      '</div>',
      '<button class="av-product-quick-view__add" type="button" data-av-qv-add' + (isAvailable ? '' : ' disabled') + '>' + (isAvailable ? 'Add to cart' : 'Sold out') + '</button>',
      '</div>',
      '<a class="av-product-quick-view__details-link" href="' + escapeHtml(product.url) + '">View details <span aria-hidden="true">&#8599;</span></a>',
      '<div class="av-product-quick-view__message" data-av-qv-message aria-live="polite"></div>',
      '<div class="av-product-quick-view__more">',
      '<h3 class="av-product-quick-view__more-title">Product details</h3>',
      product.description ? '<div class="av-product-quick-view__description">' + escapeHtml(truncateWords(product.description, 120)) + '</div>' : '',
      buildSpecs(product),
      buildResources(product),
      '</div>',
      '</div>',
      '</div>'
    ].join('');
  }

  function openModal(product, trigger) {
    if (!modal || !dialog || !product) return;
    lastTrigger = trigger || document.activeElement;
    currentProduct = product;
    selectedOptions = (product.options || []).map(function (option) {
      return option.selectedValue || (option.values && option.values[0]) || '';
    });
    renderProduct(product);
    modal.hidden = false;
    document.documentElement.classList.add('av-product-quick-view-open');
    window.setTimeout(function () {
      dialog.focus();
    }, 0);
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('av-product-quick-view-open');
    currentProduct = null;
    selectedVariant = null;
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('.bigcounter').forEach(function (counter) {
      var visible = counter.querySelector('[aria-hidden="true"]');
      if (visible) visible.textContent = count < 100 ? String(count) : '';
      var hidden = counter.querySelector('.visually-hidden');
      if (hidden) hidden.textContent = count + ' items in cart';
    });
    document.querySelectorAll('.av-navbar__count, .av-landing-hero__count, .ajax-cart-count-badge').forEach(function (counter) {
      counter.textContent = String(count);
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count || 0);
      });
  }

  function addSelectedVariant() {
    if (!currentProduct || !selectedVariant) return;
    var addButton = content.querySelector('[data-av-qv-add]');
    var message = content.querySelector('[data-av-qv-message]');
    var quantityInput = content.querySelector('[data-av-qv-qty]');
    var quantity = Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10) || 1);

    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = 'Adding...';
    }
    if (message) message.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: selectedVariant.id,
        quantity: quantity
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw new Error(error.description || 'Unable to add item.');
          });
        }
        return response.json();
      })
      .then(function () {
        return refreshCartCount();
      })
      .then(function () {
        if (message) message.textContent = 'Added to cart.';
        if (addButton) addButton.textContent = 'Added';
      })
      .catch(function (error) {
        if (message) message.textContent = error.message || 'Unable to add item.';
        if (addButton) {
          addButton.disabled = false;
          addButton.textContent = 'Add to cart';
        }
      })
      .finally(function () {
        if (addButton && message && message.textContent === 'Added to cart.') {
          window.setTimeout(function () {
            addButton.disabled = false;
            addButton.textContent = 'Add to cart';
          }, 1400);
        }
      });
  }

  ready(function () {
    modal = document.querySelector('[data-av-product-quick-view-modal]');
    if (!modal) return;
    dialog = modal.querySelector('.av-product-quick-view__dialog');
    content = modal.querySelector('[data-av-product-quick-content]');

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-av-product-quick-view]');
      if (trigger) {
        event.preventDefault();
        var data = getCardData(trigger);
        openModal(data, trigger);
        return;
      }

      if (event.target.closest('[data-av-product-quick-close]')) {
        event.preventDefault();
        closeModal();
        return;
      }

      var option = event.target.closest('[data-av-qv-option]');
      if (option && currentProduct) {
        var index = Number(option.dataset.avQvOption);
        selectedOptions[index] = option.dataset.avQvValue;
        renderProduct(currentProduct);
        return;
      }

      var thumb = event.target.closest('[data-av-qv-image]');
      if (thumb && content) {
        var image = content.querySelector('.av-product-quick-view__image');
        if (image) image.src = thumb.dataset.avQvImage;
        content.querySelectorAll('[data-av-qv-image]').forEach(function (button) {
          button.classList.toggle('is-active', button === thumb);
        });
        return;
      }

      if (event.target.closest('[data-av-qv-qty-minus], [data-av-qv-qty-plus]')) {
        var qtyInput = content.querySelector('[data-av-qv-qty]');
        if (!qtyInput) return;
        var delta = event.target.closest('[data-av-qv-qty-plus]') ? 1 : -1;
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        return;
      }

      if (event.target.closest('[data-av-qv-add]')) {
        event.preventDefault();
        addSelectedVariant();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!modal.hidden && event.key === 'Escape') {
        closeModal();
      }
    });
  });
})();
